import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AnalyticsService } from '../../core/services/analytics.service';
import { CookieService } from '../../core/services/cookie.service';
import { LanguageService } from '../../core/services/language.service';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss',
})
export class CookieBannerComponent {
  readonly cookies = inject(CookieService);
  private readonly analytics = inject(AnalyticsService);
  private readonly i18n = inject(LanguageService);

  t(key: string): string {
    return this.i18n.t(key);
  }

  accept(): void {
    this.cookies.accept();
    this.analytics.trackVisit();
  }

  reject(): void {
    this.cookies.reject();
  }
}
